window.PXUTheme = window.PXUTheme || {};

window.PXUTheme.jsGlobalProduct = {

  async init() {
    this.watchSwappers(); // Watch for changes in variant
    if(document.querySelector('[data-product-selection]')) {
      this.watchInputs();
    }
    if(document.querySelector('[data-product-atc]')) {
      this.watchATCs();
    }
    this.watchATCScroll();
  },

  watchDisabledBlocks() {
    const products = document.querySelectorAll('product');
    let enableDisabled = true;

    for(const prod of products) {
      if(!prod.querySelector('[data-product-selection]:checked')) {
        enableDisabled = false;
      }
    }

    if(enableDisabled) {
      const disabledBlocks = document.querySelectorAll('[data-product-disabled]');
      for(const block of disabledBlocks) {
        block.classList.add('enabled');
      }
    }
  },

  disableDisabledBlocks() {
    const disabledBlocks = document.querySelectorAll('[data-product-disabled]');
    for(const block of disabledBlocks) {
      block.classList.remove('enabled');
    }
  },

  // Watch inputs to show subscription options
  watchInputs() {
    const inputs = document.querySelectorAll('[data-product-selection]');
    for(const input of inputs) {
      input.addEventListener('change', (event) => {
        if(document.querySelector('.global-product__options__subscription')) {
          document.querySelector('.global-product__options__subscription').classList.add('active');
        }
        this.watchDisabledBlocks();
        this.updatePricing(inputs);
      });
    }
  },

  updatePricing(inputs) {
    let price = 0;
    let sellingPlan = false;

    for(const input of inputs) {
      if(input.checked == true) {
        if(input.dataset.quantity > 0) {
          price = Number(price) + Number(input.dataset.price*input.dataset.quantity);
        } else {
          price = Number(price) + Number(input.dataset.price);
        }
        if(input.dataset.sellingPlan) {
          sellingPlan = Number(input.dataset.price*input.dataset.quantity);
        }
      }
    }

    if(document.querySelector('[data-product-price-money]')){
      document.querySelector('[data-product-price-money]').textContent = Shopify.formatMoney(price, document.body.getAttribute("data-money-format"));
    }

    if(sellingPlan && document.querySelector('[data-product-price-text]')){
      const subscriptionPrice = Shopify.formatMoney(sellingPlan, document.body.getAttribute("data-money-format"));
      document.querySelector('[data-product-price-text]').innerHTML = `Your total today <span>+ ${subscriptionPrice} every 6 months</span>`;
    } else if(document.querySelector('[data-product-price-text]')) {
      document.querySelector('[data-product-price-text]').innerHTML = `Your total`;
    }

    const targetContainer = document.querySelector('.global-product .additional_payment_container');
    if(sellingPlan) {
      targetContainer.classList.add('hidden');
    } else {
      targetContainer.classList.remove('hidden');
    }
  },

  // Watch for changes in variant selection and update gallery
  watchSwappers() {
    const variantSelectors = document.querySelectorAll('[data-swapper]');
    const swappableElements = document.querySelectorAll('[data-colour-swap]');
    
    if (variantSelectors.length === 0) {
      console.warn('No variant swappers found.');
      return;
    }

    variantSelectors.forEach((swapper) => {
      swapper.addEventListener('click', (event) => {
        const newVariant = event.target.dataset.swapper;
        this.updateGallerySwatches(event.target.dataset.swapper);
        if (swappableElements.length > 0) {
          for (const el of swappableElements) {
            const inputs = document.querySelectorAll('product input');
            for(const input of inputs) {
              if (input.checked) {
                input.checked = false; // Uncheck all radios
              }
              if (input.dataset.colour) {
                if (input.dataset.colour === newVariant && input.dataset.defaultOption == "true") {
                  input.checked = true;
                }
              }
            }
            if (el.dataset.colourSwap === newVariant) {
              el.classList.add('active');
            } else {
              el.classList.remove('active');
            }
          }
        } else {
          console.warn('No swappable elements found.');
        }
      });
    });
  },

  updateGallerySwatches(swapper) {
    if(document.querySelector('.gallery-swatches .gallery-swatch')) {
      document.querySelector(`.gallery-swatches .gallery-swatch.active`).classList.remove('active');
      document.querySelector(`.gallery-swatches .gallery-swatch.swatch-${swapper}`).classList.add('active');
    }
  },

  watchATCs() {
    const addToCartButtons = document.querySelectorAll('[data-product-atc]');
    
    for (const btn of addToCartButtons) {
      btn.addEventListener('click', async (event) => {
        event.preventDefault();
        btn.classList.add('loading');
  
        let items = [];
        let addProducts = true;

        let sellingPlanParent = btn.dataset.sellingPlan;
  
        // Loop through all products and build the cart items
        if(document.querySelector('.global-product product')) {
        const products = document.querySelectorAll('.global-product product');
          for (const p of products) {
            const variant = p.querySelector('[data-product-selection]:checked');

            let allowEmpty = false;
            if(p.dataset.allowEmpty) {
              allowEmpty = true;
            }

            // Skip if no variant is selected          
            if (!variant && !allowEmpty) {
              p.scrollIntoView({ behavior: 'smooth', block: 'center' });
              p.classList.add('highlight');
              setTimeout(() => p.classList.remove('highlight'), 1000);
              addProducts = false;
              btn.classList.remove('loading');
              return;
            }
    
            if(variant) {
              const id = variant.value;
              let sellingPlan = null;

              if(!sellingPlanParent) {
                sellingPlan = variant.dataset.sellingPlan || null;
              } else {
                if(variant.dataset.sellingPlan) {
                  sellingPlan = variant.dataset.sellingPlan
                } else {
                  sellingPlan = sellingPlanParent;
                }
              }

              const quantity = variant.dataset.quantity ? parseInt(variant.dataset.quantity, 10) : 1;

              if(id == 'false') {
                continue;
              }
      
              items.push({
                id,
                quantity,
                ...(sellingPlan ? { selling_plan: sellingPlan } : {})
              });
            }
          }
        } else {
          const variantId = btn.dataset.defaultProduct;
          items.push({
            id: variantId,
            quantity: 1
          })
        }
  
        if (items.length === 0 || addProducts == false) return; // Exit if no items to add
  
        try {
          // Add items to cart
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items })
          });
  
          if (!response.ok) throw new Error('Failed to add to cart');
  
          window.PXUTheme.jsCart.updateCart();
          window.PXUTheme.jsCart.toggleCart('show');

          this.clearInputs();
          this.disableDisabledBlocks();

          btn.classList.remove('loading');
        } catch (error) {
          console.error('Error adding to cart:', error);
          btn.classList.remove('loading');
        }
      });
    }
  },

  clearInputs() {
    const allInputs = document.querySelectorAll('product input:checked');
    
    for(const input of allInputs) {
      if(!input.dataset.defaultOption) {
        input.checked = false;
        if(input.dataset.colour && input.closest('product')) {
          const product = input.closest('product');
          const colour = input.dataset.colour;
          const defaultInput = product.querySelector(`input[data-colour="${colour}"][data-default-option]`);
          defaultInput.checked = true;
        }
      }
    }

    if(document.querySelector('.global-product__options__subscription')){
      document.querySelector('.global-product__options__subscription').classList.remove('active');
    }

    if(document.querySelector('[data-default-price]')) {
      for(const priceEl of document.querySelectorAll('[data-default-price]')){
        if(priceEl.dataset.defaultPrice) {
          priceEl.textContent = priceEl.dataset.defaultPrice;
        }
      }
    }
  },

  watchATCScroll() {
    let currentScroll = window.scrollY;
    let element = document.querySelector('.global-product__atc-bar');

    const checkATCScroll = () => {
      if (window.scrollY > 0) {
        element.classList.remove('scrolled');
      } else {
        element.classList.add('scrolled');
      }

      if (window.scrollY > currentScroll) {
        element.classList.add('show');
      } else {
        element.classList.remove('show');
      }

      currentScroll = window.scrollY;

      const btn = element.querySelector('.btn');
      const productSection = document.querySelector('.global-section-parent.global-product');
      btn.addEventListener('click', (event) => {
        event.preventDefault();
        document.querySelector('#header').classList.remove('show');
        element.classList.remove('show');
        productSection.scrollIntoView({ behavior: "smooth" });
      });
    };
  
    // Run the check immediately on page load
    checkATCScroll();
  
    // Add the scroll event listener
    document.addEventListener('scroll', checkATCScroll);
  },
}

document.addEventListener('DOMContentLoaded', () => {
  window.PXUTheme.jsGlobalProduct.init();

  if (document.querySelector('.global-product .shopify-payment-button')) {
    // Get the payment button element
    const paymentButton = document.querySelector('.global-product .shopify-payment-button');
    // Get the target container where the payment button should be moved
    const targetContainer = document.querySelector('.global-product .additional_payment_container');
    
    // If the container exists, move the payment button into it
    if (targetContainer) {
      targetContainer.appendChild(paymentButton);
    }
  }
});